<script lang="ts">
	import type { TooltipOptions } from '$lib/actions/tooltip/types';
	import type { IconName } from '$lib/components/icons/types';
	import type { ClassValue } from 'svelte/elements';
	import { tooltip } from '$lib/actions/tooltip/tooltip';

	interface Props {
		icon?: IconName;
		ariaLabel?: string;
		ariaHidden?: boolean | 'true' | 'false';
		tag?: string;
		tooltipOptions?: TooltipOptions;
		class?: ClassValue;
	}

	const {
		icon,
		ariaLabel,
		ariaHidden,
		tag = 'div',
		tooltipOptions,
		class: classes,
	}: Props = $props();

</script>

<svelte:element this={tag} aria-label={ariaLabel} class={[`icon-${icon} inline-block`, classes]} aria-hidden={ariaHidden} use:tooltip={tooltipOptions} />
